module.exports = __webpack_public_path__ + "static/media/3.7_preview.3e9adba6.png";